export default __webpack_public_path__ + "static/3-f23ecd64e19df07ecea0bbec6991f646.jpeg";